import React from 'react';
import { Button } from 'Views/Components/Button/Button';
import { useOrganisationStore } from 'Global/Organisations/OrganisationsStore';
import { observer } from 'mobx-react';
import { isNullOrUndefined } from '../../../../Util/TypeGuards';
import OrganisationDropDown from '../Home/OrganisationDropDown';
import useDeviceDetect from '../../../../Hooks/useDeviceDetect';

function OrganisationNavBarButton({ transparent }: { transparent: boolean }) {
	const orgStore = useOrganisationStore();
	const { isIpad } = useDeviceDetect();

	const showOrganisationSelection =
		(orgStore.organisations?.length ?? 0) > 1 && isNullOrUndefined(orgStore.selectedOrganisation);

	const [showMenu, setShowMenu] = React.useState(false);

	if (showOrganisationSelection) {
		return <></>;
	}

	return (
		<div
			role="button"
			className="org-selection custom-input-group__dropdown"
			tabIndex={0}
			// onBlur={() => {
			// 	setShowMenu(false);
			// }}
		>
			<Button
				className={`organisation-nav-bar__button ${isIpad ? 'icon-only' : ''}`}
				icon={{ icon: 'location-pin', iconPos: 'icon-left' }}
				onClick={() => {
					setShowMenu(!showMenu);
				}}
			>
				{isIpad ? '' : (orgStore?.selectedOrganisation?.name ?? 'Set location')}
			</Button>
			<OrganisationDropDown
				organisations={orgStore.organisations}
				show={showMenu}
				toggleShowMenu={() => {
					setShowMenu(!showMenu);
				}}
				setShowOrganisationSelection={setShowMenu}
			/>
		</div>
	);
}

export default observer(OrganisationNavBarButton);
